import { Stack } from '@mui/material';
import { OptionsTable } from './OptionsTable';

export function RadioOptions() {
  return (
    <Stack direction="row" spacing={1} sx={{ p: 1 }}>
      <title>IR3 | Radio Options</title>
      <OptionsTable name="radioType" title="Types" />
    </Stack>
  );
}
